<template>
  <div class="teacherLayoutRootBox">
    <div class="header">
      <div class="title">数据统计</div>
      <div>
        <m-selects @change="selectChange" @courseChange="()=>courseTabChange(1)"></m-selects>
      </div>
    </div>
    <div class="main">
      <div role="aphorism">
        <m-aphorism></m-aphorism>
      </div>
      <div role="openingStatus">
        <m-opening-status :left-list="openingStatus" :ranking="ranking" :hide-right="true"></m-opening-status>
      </div>
      <div data-title="专业人数" role="numberOfProfessionals">
        <m-title title-text="专业人数" :tip-text="tipText"></m-title>
        <m-course-tab @change="(type)=>courseTabChange(type,true)" :current-type="courseType"></m-course-tab>
        <div style="flex:1;width: 100%;">
          <m-chart :option-data="numberOfProfessionalsBarData"></m-chart>
        </div>
      </div>
      <div data-title="选课量排行" role="studentRanking">
        <m-ranking-list style="margin-top: 30px" :min-titles="{column3Name:'选课量'}"
                        :ranking-list="learningRanking"
                        :total="learningRanking.total"
                        @pageChange="getLearningRanking">
        </m-ranking-list>
      </div>
      <div data-title="学习时长" role="learningDuration">
        <m-title title-text="学习时长" :tip-text="tipText+'，显示从当前时间往前一周或一个月的数据'"></m-title>
        <div class="learningDuration">
          <m-chart :option-data="learningDurationBrokenLineData" :tip-style="tipStyle"></m-chart>
        </div>
        <div class="timeSwitchBox">
          <m-switch @change="timeSwitchChange"></m-switch>
        </div>
      </div>
      <div data-title="" role="creditHourRanking">
        <m-title title-text="学时排行" tip-text="该模块统计数字课程、实践教学的学习时长及讨论笔记等教学工具的使用时长"></m-title>
        <m-ranking-list style="margin-top: 30px"
                        :ranking-list="creditHourRanking"
                        :total="creditHourRanking.total"
                        :is-date="true"
                        @pageChange="findPage">

        </m-ranking-list>
      </div>
      <div data-title="课程进度和排行" role="courseProgress" v-if="false">
        <m-line-progress :progress="classProgress[rankingProgressTag.courseProgress]"
                         progressClass="blue"></m-line-progress>
        <m-ranking-list style="flex: 1" :min-titles="{column3Name:'进度'}"
                        :ranking-list="classProgressList[rankingProgressTag.courseProgress]"
                        :total="classProgressList[rankingProgressTag.courseProgress].total"
                        @pageChange="(pageNum)=>getClassProgressList('',pageNum,false)">
          >
        </m-ranking-list>
      </div>
      <div data-title="课程实践练习进度和排行" role="exerciseProgress" v-if="false">
        <m-line-progress :progress="classProgress[rankingProgressTag.exerciseProgress]"
                         progressClass="green"></m-line-progress>
        <m-ranking-list style="flex: 1" :min-titles="{column3Name:'进度'}"
                        :ranking-list="classProgressList[rankingProgressTag.exerciseProgress]"
                        :total="classProgressList[rankingProgressTag.exerciseProgress].total"
                        @pageChange="(pageNum)=>getClassProgressList(rankingProgressTag.exerciseProgress,pageNum,false)">
        </m-ranking-list>
      </div>
      <div data-title="实践教学进度和排行" role="teachingProgress" v-if="false">
        <m-line-progress :progress="classProgress[rankingProgressTag.teachingProgress]"
                         progressClass="yellow"></m-line-progress>
        <m-ranking-list style="flex: 1" :min-titles="{column3Name:'进度'}"
                        :ranking-list="classProgressList[rankingProgressTag.teachingProgress]"
                        :total="classProgressList[rankingProgressTag.teachingProgress].total"
                        @pageChange="(pageNum)=>getClassProgressList(rankingProgressTag.teachingProgress,pageNum,false)">
        </m-ranking-list>
      </div>
      <div data-title="测验进度" role="testProgress">
        <m-line-progress :progress="testProgress" progressClass="yellow" style="margin-bottom: 50px"></m-line-progress>
        <div class="cProgressBox">
          <m-circular-progress :score="testScore"></m-circular-progress>
        </div>
      </div>
      <div data-title="" role="testScore">
        <m-title title-text="测验分数" :tip-text="testTipText"></m-title>
        <div class="learningDuration">
          <m-chart :option-data="testScoreBrokenLineData"></m-chart>
        </div>
      </div>
      <div data-title="笔记和讨论" role="notesAndDiscussions">
        <div style="height: 55%;width: 80%">
          <m-notes-and-discussions :data-list="notesAndDiscusCounts"></m-notes-and-discussions>
        </div>
      </div>
      <div data-title="笔记榜" role="notebookList">
        <m-ranking-list style="flex: 1"
                        :min-titles="{column3Name:'笔记条数'}"
                        :ranking-list="noteCountSort"
                        :total="noteCountSort.total"
                        @pageChange="getNoteCountSort">
        </m-ranking-list>
      </div>
      <div data-title="讨论榜" role="discussionBoard">
        <m-ranking-list style="flex: 1"
                        :min-titles="{column3Name:'讨论条数'}"
                        :ranking-list="discussCountSort"
                        :total="discussCountSort.total"
                        @pageChange="getDiscussCountSort">

        </m-ranking-list>
      </div>
    </div>
  </div>
</template>

<script>

import mixinsData, {getBarData, getLineData} from '../mixins'
import {
  getClassCount,
  getStudyCount,
  numberOfProfessionals,
  getLearningRanking,
  findTeacherRank,
  getClassProgress,
  getExamProgress,
  getExamPaperAvgScore,
  getNoteDiscussNum,
  getNoteCountSort,
  getDiscussCountSort,
  getExamScoreList,
  getClassProgressList,
  findList,
  findPage,

} from "@/api/PostUrl";

export default {
  name: "teacherLayout",
  mixins: [mixinsData],
  data() {
    return {
      learningRanking: [],//选课量排行榜
      discussCountSort: [],//讨论排行榜
      noteCountSort: [],//笔记排行榜
      creditHourRanking: [],//学时排行列表
      numberOfProfessionalsBarData: getBarData(['未学人数', '在学人数', '已学人数'], '', '个'),
      learningDurationBrokenLineData: getLineData(['学习时长'], '', '秒'),
      testScoreBrokenLineData: getLineData(['班级最低分', '班级平均分', '班级最高分'], '', '分'),
      courseType: '1',
      ranking: {title: '专业排名', score: '0', totalNum: '0'},
      testProgress: 0,//测验进度
      testScore: 0,//测验平均分数
      rankingProgressTag: {
        courseProgress: 0,
        exerciseProgress: 1,
        teachingProgress: 2
      },
      classProgress: [0, 0, 0],
      classProgressList: [[], [], []],
      openingStatus: [
        {//待上课
          icon: 'waiting',
          title: '教学班待开始',
          content: '0个',
          tip: '该数据统计的是当前课程下教学班的整体情况'
        },
        {//开课中
          icon: 'begin',
          title: '教学班开课中',
          content: '0个',
          tip: '该数据统计的是当前课程下教学班的整体情况'
        },
        {//已结课
          icon: 'completed',
          title: '教学班已结课',
          content: '0个',
          tip: '该数据统计的是当前课程下教学班的整体情况'
        }, {//听众
          icon: 'listener',
          title: '听课学员',
          content: '0个'
        }
      ],
      notesAndDiscusCounts: [
        {
          content: '0条',
          describe: '笔记条数'
        },
        {
          content: '0条',
          describe: '讨论条数'
        },
        {
          content: '0条',
          describe: '笔记评论数'
        },
        {
          content: '0条',
          describe: '讨论回复数'
        },
      ],
      fromData: {}
    }
  },
  methods: {
    selectChange(fromData) {
      this.fromData = fromData
      this.getClassCount()
      this.getNumberOfProfessionals()
      this.getLearningRanking()
      this.getClassProgress()
      this.getClassProgressList()
      this.getExamProgress()
      this.getExamPaperAvgScore()
      this.getNoteDiscussNum()
      this.findTeacherRank()
      this.getExamScoreList()
      this.getNoteCountSort()
      this.getDiscussCountSort()
      this.timeSwitchChange(this.currentSwitchTime)
      this.findPage()
    },
    //获取班级学生操作数量
    async getClassCount(status = 0) {
      const param = {...this.fromData}
      if (status > 2) {
        const count = await this.$apiPost.httpPostForMap(getStudyCount, param)
        this.openingStatus[status].content = `${count}个`
      } else {
        param.status = status
        const count = await this.$apiPost.httpPostForMap(getClassCount, param)
        this.openingStatus[status].content = `${count}个`
        await this.getClassCount(++status)
      }
    },
    courseTabChange(courseType, isTab) {
      this.courseType = courseType
      isTab && this.getNumberOfProfessionals()
    },
    //获取专业人数
    async getNumberOfProfessionals() {
      Object.assign(numberOfProfessionals.params, this.fromData)
      if (String(this.courseType) !== '1') {
        numberOfProfessionals.params.courseId = ''//如果是全部则传空
        numberOfProfessionals.params.classId = ''//如果是全部则传空
      }
      const data = await this.$apiPost.httpPostForMap(numberOfProfessionals)
      this.setNumberOfProfessionals(data || [])
    },
    //设置专业人数配置
    setNumberOfProfessionals(data = []) {
      this.numberOfProfessionalsBarData.xAxis.data = data.map(item => item.courseName)
      const keys = ['unNum', 'studyNum', 'finNum']
      keys.forEach((key, index) => this.numberOfProfessionalsBarData.series[index].data = data.map(item => item[key] > 0 ? item[key] : 0))
    },
    //选课量排行
    async getLearningRanking(pageNum = 1) {
      Object.assign(getLearningRanking.params, this.fromData)
      getLearningRanking.params.userId = this.userId
      getLearningRanking.params.pageNum = pageNum
      const data = await this.$apiPost.httpPostForMap(getLearningRanking)
      const list = data.list || []
      this.learningRanking = list.map(({name, num: content}) => ({name, content}))
      this.learningRanking.total = data.total
    },
    //获取班级排行
    async findTeacherRank() {
      findTeacherRank.params.courseId = this.fromData.courseId
      const data = await this.$apiPost.httpPostForMap(findTeacherRank)
      Object.assign(this.ranking, {...data})
    },
    //获取班级教学平均进度
    async getClassProgress(catalogType = '') {
      if (catalogType > 1) return
      Object.assign(getClassProgress.params, this.fromData)
      getClassProgress.params.userId = this.userId
      getClassProgress.params.catalogType = catalogType
      const data = await this.$apiPost.httpPostForMap(getClassProgress)
      if (catalogType === '') {
        catalogType = 0
      } else {
        catalogType++
      }
      this.$set(this.classProgress, catalogType, data || 0)
      await this.getClassProgress(catalogType)
    },
    //获得测验平均进度
    async getExamProgress() {
      Object.assign(getExamProgress.params, this.fromData)
      getExamProgress.params.userId = this.userId
      const data = await this.$apiPost.httpPostForMap(getExamProgress)
      this.testProgress = (data || 0) * 1000 / 10
    },
    //获得测验平均分数
    async getExamPaperAvgScore() {
      Object.assign(getExamPaperAvgScore.params, this.fromData)
      getExamPaperAvgScore.params.userId = this.userId
      const data = await this.$apiPost.httpPostForMap(getExamPaperAvgScore)
      this.testScore = data || 0
    },
    //获取讨论，笔记，回复条数
    async getNoteDiscussNum() {
      Object.assign(getNoteDiscussNum.params, this.fromData)
      getNoteDiscussNum.params.userId = this.userId
      const data = (await this.$apiPost.httpPostForMap(getNoteDiscussNum)) || {}
      const defaultData = {
        noteNum: 0, //笔记条数
        discussNum: 0, //讨论条数
        publishCommentNum: 0, //笔记评论数
        replayTheamNum: 0 //讨论回复数
      }
      Object.entries(defaultData).forEach(([key, value], index) => this.notesAndDiscusCounts[index].content = `${data[key] || value}条`)
    },
    //获取笔记排行榜
    async getNoteCountSort(pageNum = 1) {
      Object.assign(getNoteCountSort.params, this.fromData)
      getNoteCountSort.params.pageNum = pageNum
      getNoteCountSort.params.userId = this.userId
      const data = await this.$apiPost.httpPostForMap(getNoteCountSort)
      let list = data.list || []
      this.noteCountSort = list.map(({name, num: content}) => ({name, content}))
      this.noteCountSort.total = data.total
    },
    //获取讨论排行榜
    async getDiscussCountSort(pageNum = 1) {
      Object.assign(getDiscussCountSort.params, this.fromData)
      getDiscussCountSort.params.pageNum = pageNum
      getDiscussCountSort.params.userId = this.userId
      const data = await this.$apiPost.httpPostForMap(getDiscussCountSort)
      let list = data.list || []
      this.discussCountSort = list.map(({name, num: content}) => ({name, content}))
      this.discussCountSort.total = data.total
    },
    //学习时长折线图
    async findList(startDate, endDate) {
      findList.params.classId = this.fromData.classId
      findList.params.courseId = this.fromData.courseId
      findList.params.startDate = this.fromData.startDate
      findList.params.endDate = this.fromData.endDate
      if (startDate && endDate) {
        findList.params.startDate = startDate
        findList.params.endDate = endDate
      }
      const data = await this.$apiPost.httpPostForMap(findList)
      this.setLearningDurationBrokenLineData(data || [])
    },
    setLearningDurationBrokenLineData(data = []) {
      this.learningDurationBrokenLineData.xAxis.data = data.map(item => item.studyDate)
      const keys = ['time']
      keys.forEach((key, index) => this.learningDurationBrokenLineData.series[index].data = data.map(item => item[key] > 0 ? item[key] : 0))
    },
    //学时排行
    async findPage(pageNum = 1) {
      findPage.params.pageNum = pageNum
      findPage.params.courseId = this.fromData.courseId
      findPage.params.classId = this.fromData.classId
      const data = await this.$apiPost.httpPostForMap(findPage)
      const list = data.list || []
      this.creditHourRanking = list.map(({name, time: content}) => ({name, content}))
      this.creditHourRanking.total = data.total
    },
    //查询测验分数分布范围 折线图
    async getExamScoreList() {
      this.fromData.userId = this.userId
      Object.assign(getExamScoreList.params, this.fromData)
      const data = await this.$apiPost.httpPostForMap(getExamScoreList)
      this.setTestScoreBrokenLineData(data || [])
    },
    //设置测验分数分布范围配置
    setTestScoreBrokenLineData(data = []) {
      this.testScoreBrokenLineData.xAxis.data = data.map(item => item.paperName)
      let maxScore = null
      if (data.length) {
        maxScore = Math.max.apply(null,data.map(item => item.maxScore))
      }
      this.setFractionYAxisMax(this.testScoreBrokenLineData,maxScore)
      const keys = ['minScore', 'avgScore', 'maxScore']
      keys.forEach((key, index) => this.testScoreBrokenLineData.series[index].data = data.map(item => item[key] > 0 ? item[key] : 0))
      this.testScoreBrokenLineData.additionalInfo = {
        title: '所在目录',
        values: data,
        key: 'lastCatalogName'
      }
    },
    //课程实践、 实践教学排行
    async getClassProgressList(catalogType = '', pageNum = 1, isRecursion = true) {
      if (catalogType > 1) return
      Object.assign(getClassProgressList.params, this.fromData)
      getClassProgressList.params.userId = this.userId
      getClassProgressList.params.catalogType = catalogType
      getClassProgressList.params.pageNum = pageNum
      const data = await this.$apiPost.httpPostForMap(getClassProgressList)
      if (catalogType === '') {
        catalogType = 0
      } else {
        catalogType++
      }
      this.$set(this.classProgressList, catalogType, data.list || [])
      this.$set(this.classProgressList[catalogType], 'total', data.total)
      isRecursion && await this.getClassProgressList(catalogType)
    },
    async timeSwitchChange(item) {
      await this.weekMonthChange(item, this.findList)
    },
  },
}
</script>

<style lang="scss" scoped>
.teacherLayoutRootBox {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  & > .header {
    position: sticky;
    top: 0;
    z-index: 99;
    width: 100%;
    height: 56px;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0 0 0 4px;
    box-shadow: -2px 2px 10px #f0f0f3;

    & > .title {
      font-size: 20px;
      font-weight: bold;
      margin-left: 20px;
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      width: 4px;
      height: 24px;
      border-radius: 0 4px 4px 0;
      background-color: #5397F7;
    }
  }

  & > .main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: calc(0.12 * var(--fontSize));
    padding: 0 40px 0 0;
    box-sizing: border-box;
    margin-top: calc(0.12 * var(--fontSize));

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      background-color: white;
      position: relative;
    }

    & > div:before {
      content: attr(data-title);
      position: absolute;
      left: calc(0.3 * var(--fontSize));
      top: calc(0.23 * var(--fontSize));
      font-size: calc(0.18 * var(--fontSize));
    }

    & > div[role=aphorism] {
      grid-column: 1 / span 3;
      //height: calc(0.73 * var(--fontSize));
    }


    & > div[role=openingStatus] {
      grid-column: 1 / span 3;
      height: calc(1.1 * var(--fontSize));
      background-color: transparent;
    }

    & > div[role=numberOfProfessionals] {
      grid-column: 1 / span 2;
      height: calc(3.88 * var(--fontSize));
      min-height: 388px;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    & > div[role=studentRanking] {
      height: calc(3.88 * var(--fontSize));
      min-height: 388px;
    }

    & > div[role=learningDuration] {
      grid-column: 1 / span 2;
      height: calc(3.88 * var(--fontSize));
      min-height: 388px;
      position: relative;

      .learningDuration {
        width: 100%;
        height: 100%;
      }

      .timeSwitchBox {
        position: absolute;
        z-index: 8;
        top: 12%;
        right: 6%;
      }
    }

    & > div[role=creditHourRanking] {
      height: calc(3.88 * var(--fontSize));
      min-height: 388px;
    }

    & > div[role=courseProgress] {
      height: calc(4.96 * var(--fontSize));
      min-height: 496px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    & > div[role=exerciseProgress] {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    & > div[role=teachingProgress] {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    & > div[role=testProgress] {
      height: calc(4.60 * var(--fontSize));
      min-height: 460px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      padding-top: 20px;
      box-sizing: border-box;

      .cProgressBox {
        width: calc(2.1 * var(--fontSize));
        height: calc(2.1 * var(--fontSize));
      }
    }

    & > div[role=testScore] {
      grid-column: 2 / span 2;

      .learningDuration {
        width: 100%;
        height: 100%;
      }
    }

    & > div[role=notesAndDiscussions] {
      height: calc(3.88 * var(--fontSize));
      min-height: 388px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/layout/teacherLayout.vue